import { CustomPageHeader, Text } from '@src/components';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import InvoiceFilter from './InvoiceFilter';
import InvoiceList from './InvoiceList';

const CarInvoices = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [dispatch]);

  return (
    <CustomPageHeader
      data-testid="manage-my-cards"
      title={<Text t="trackInvoice" />}
      showBreadCrumb
      showHelpButton
      routes={['myInvoices']}
    >
      <InvoiceFilter />
      <InvoiceList />
    </CustomPageHeader>
  );
};

export default CarInvoices;
